import GroupGiftRegItemCard from './group-gift-reg-item-card'

export default GroupGiftRegItemCard
